import { customAxios } from './customAxios'
export function getRiepilogoPdf(idPratica) {
  const config = {
    params: {
      idAdeguataVerifica: idPratica.toString(),
    },
    headers: {
      Accept: '*/*',
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const getRiepilogo = customAxios
    .get(
      process.env.REACT_APP_BACKEND_HOST +
        `/` +
        process.env.REACT_APP_PATH_NEW_PREFIX +
        `/pdf/get/riepilogo?`,
      config,
    )
    .then(response => response)

  return getRiepilogo
}
